var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabAnamnesisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C18.07 1 23 5.93 23 12C23 18.07 18.07 23 12 23C5.93 23 1 18.07 1 12C1 5.93 5.93 1 12 1ZM12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0Z",
    fill: "#2560A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.42 5.23V6.7H8.79V5.23H10.47C10.83 5.68 11.38 5.97 12 5.97C12.62 5.97 13.17 5.68 13.53 5.23H15.41M11.99 2.31C11.05 2.31 10.28 3.08 10.28 4.02C10.28 4.09 10.29 4.16 10.3 4.23H8.27C7.99 4.23 7.77 4.45 7.77 4.73V5.04H6.75C6.47 5.04 6.25 5.26 6.25 5.54V19.2C6.25 19.48 6.47 19.7 6.75 19.7H17.22C17.5 19.7 17.72 19.48 17.72 19.2V5.54C17.72 5.26 17.5 5.04 17.22 5.04H16.4V4.73C16.4 4.45 16.18 4.23 15.9 4.23H13.67C13.67 4.16 13.69 4.09 13.69 4.02C13.69 3.08 12.92 2.31 11.98 2.31H11.99ZM11.99 4.97C11.46 4.97 11.03 4.54 11.03 4.01C11.03 3.48 11.46 3.05 11.99 3.05C12.52 3.05 12.95 3.48 12.95 4.01C12.95 4.54 12.52 4.97 11.99 4.97ZM8.28 7.7H15.91C16.19 7.7 16.41 7.48 16.41 7.2V6.04H16.73V18.7H7.27V6.04H7.79V7.2C7.79 7.48 8.01 7.7 8.29 7.7H8.28Z",
    fill: "#2560A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.59 8.5H11.41V9.39H10.52V10.57H11.41V11.46H12.59V10.57H13.48V9.39H12.59V8.5Z",
    fill: "#2560A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.21 12.77H8.78002C8.57002 12.77 8.40002 12.94 8.40002 13.15C8.40002 13.36 8.57002 13.53 8.78002 13.53H15.21C15.42 13.53 15.59 13.36 15.59 13.15C15.59 12.94 15.42 12.77 15.21 12.77Z",
    fill: "#2560A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.21 14.48H8.78002C8.57002 14.48 8.40002 14.65 8.40002 14.86C8.40002 15.07 8.57002 15.24 8.78002 15.24H15.21C15.42 15.24 15.59 15.07 15.59 14.86C15.59 14.65 15.42 14.48 15.21 14.48Z",
    fill: "#2560A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.21 16.18H8.78002C8.57002 16.18 8.40002 16.35 8.40002 16.56C8.40002 16.77 8.57002 16.94 8.78002 16.94H15.21C15.42 16.94 15.59 16.77 15.59 16.56C15.59 16.35 15.42 16.18 15.21 16.18Z",
    fill: "#2560A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.69 5.06H8.52002L8.66002 6.87L13.05 6.96H15.77L15.69 5.06Z",
    fill: "#2560A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabAnamnesisIcon);
export default __webpack_public_path__ + "static/media/TabAnamnesisIcon.fb8cf64785c21db8898fa364526c59b9.svg";
export { ForwardRef as ReactComponent };